<template>
  <div class="starRate-container">
    <div class="starRate-title">
      <slot>Avaliação</slot>
    </div>
    <div>
      <template v-for="n in 5" >
        <template v-if="n <= teste">
          <v-icon class="starRate-stars" :key="n">star</v-icon>
        </template>
        <template v-else-if="1 > n - teste  > 0">
          <v-icon class="starRate-stars" :key="n">star_half</v-icon>
        </template>
        <template v-else>
          <v-icon :key="n">star_border</v-icon>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'starRate',
  props: ['value'],

  data () {
    return {
      teste: 0.5,
      avaliacao: true,
      starCount: 2
    }
  },

  methods: {
    hover (key) {
      this.starCount = key
    }
  }
}
</script>
<style>
.starRate-stars{
  color: #e8d04c!important;
}
</style>



// WEBPACK FOOTER //
// StarRate.vue?ce80368c